import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KONAMI = [
  "ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown",
  "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight",
  "b", "a",
];

export default function KonamiCode() {
  const [unlocked, setUnlocked] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === KONAMI[index]) {
        const next = index + 1;
        if (next === KONAMI.length) {
          setUnlocked(true);
          setIndex(0);
          setTimeout(() => setUnlocked(false), 5000);
        } else {
          setIndex(next);
        }
      } else {
        setIndex(0);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [index]);

  return (
    <AnimatePresence>
      {unlocked && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.4, type: "spring" }}
          className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[70] bg-[#09090b] border border-[#F47B20] px-6 py-4 clip-tactical"
        >
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F47B20] mb-1">
            ◈ KONAMI CODE ACTIVATED
          </div>
          <div className="font-display font-bold text-xl text-white text-center">
            +30 LIVES
          </div>
          <div className="font-mono text-[9px] text-white/30 text-center mt-1">
            ↑↑↓↓←→←→BA
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
